import { getThresholdSchema } from './thresholdSchema';

const getProperties = (variables = []) => ({
  title: {
    type: 'string',
    title: 'Title',
  },
  layout: {
    type: 'string',
    title: 'Layout',
    default: 'vertical',
    // inverted layout naming due to issues when switching in component
    oneOf: [
      {
        enum: ['vertical'],
        title: 'horizontal',
      },
      {
        enum: ['horizontal'],
        title: 'vertical',
      },
    ],
  },
  decimals: {
    default: 'auto',
    title: 'Decimals',
    type: 'string',
    enum: ['auto', '0', '1', '2', '3', '4', '5'],
  },
  singleSignal: {
    type: 'boolean',
    title: 'Single Signal',
    default: false,
  },
  singleSignalId: {
    type: 'string',
    title: 'Signal ID',
  },
  ...getThresholdSchema(variables),
});

export const getSchema = (variables = []) => ({
  type: 'object',
  properties: getProperties(variables),
});

export const schema = getSchema();

export const uiSchema = {
  thresholds: {
    areaItems: {
      'ui:options': {
        orderable: false,
      },
    },
    linearItems: {
      'ui:options': {
        orderable: false,
      },
    },
  },
  singleSignal: {
    'ui:widget': 'hidden',
  },
  singleSignalId: {
    'ui:widget': 'hidden',
  },
};
